import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kTermsConditionsURL } from "../utils/constants/apiUrls";
import { SIX_MONTHS_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import MarkdownRender from "../components/common/MarkdownRender";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";
import { TERMS_AND_CONDITIONS_URL } from "../utils/constants/websiteUrls";
import { TabNoData } from "../components/common/NoData";

const TermsAndCondition = ({ termsAndCondition }) => {
  // SAFE FIX: Provide an empty object default to prevent top-level destructuring crashes
  const { terms_condition: termsAndConditionInfo = "" } =
    termsAndCondition || {};

  const url = TERMS_AND_CONDITIONS_URL;

  return (
    <>
      {customStaticSeoConfig("Terms and Conditions")}
      <TextNavBackground title="Terms and Conditions" />

      {/* SAFE FIX: Evaluate the actual string payload variable instead of the wrapper object */}
      {termsAndConditionInfo === "" && <TabNoData />}

      {termsAndConditionInfo !== "" && (
        <MarkdownRender
          title={"Asante Kotoko SC Terms and Conditions"}
          caption={
            "Terms and conditions for using the Asante Kotoko website and app."
          }
          url={url}
          markdownData={termsAndConditionInfo}
        />
      )}
    </>
  );
};

export default TermsAndCondition;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const termsAndCondition = await apiWrapper.get(kTermsConditionsURL, token);

  return {
    props: {
      // SAFE FIX: Pass an empty object fallback down to preserve rendering properties safely
      termsAndCondition: termsAndCondition?.data || {},
    },
    revalidate: SIX_MONTHS_REFRESH_INTERVAL_SECONDS,
  };
};
